module.exports = __webpack_public_path__ + "fonts/Nimbus-Sans-D-OT-Bold.ad8f757c.woff";